import { DatePicker as DatePickerAnt } from 'antd';
import type { Moment } from 'moment';
import momentGenerateConfig from 'rc-picker/lib/generate/moment';
import styled from 'styled-components';
import { CALLER_COLORS as C } from '../tokens';

// antd-backed composer controls (duration Select + date picker) restyled to match
// the staff / start-time chips. Kept separate from the plain styled-components.

// Duration antd Select restyled to match the chips.
export const DurationWrap = styled.div`
  width: 100%;
  .ant-select {
    width: 100%;
    min-width: 0;
  }
  .ant-select:not(.ant-select-disabled) .ant-select-selector {
    height: 48px;
    padding: 0 16px;
    display: flex;
    align-items: center;
    background: ${C.lightBtnBg};
    border: 1px solid ${C.border};
    border-radius: 11px;
    box-shadow: none;
  }
  .ant-select-selection-item {
    color: ${C.navy};
    font-size: 16px;
    font-weight: 600;
  }
  .ant-select-arrow {
    color: ${C.navy};
  }
`;

// Compact, chip-styled moment date picker (replaces the modal-sized reused one).
const MomentDatePicker = DatePickerAnt.generatePicker<Moment>(momentGenerateConfig);
export const DateChip = styled(MomentDatePicker)`
  align-self: flex-start;
  height: 36px;
  min-width: 132px;
  padding: 0 12px;
  background: ${C.lightBtnBg};
  border: 1px solid ${C.border};
  border-radius: 9px;
  box-shadow: none;
  &.ant-picker-focused,
  &.ant-picker:hover {
    border-color: ${C.border};
    box-shadow: none;
  }
  .ant-picker-input > input {
    color: ${C.navy};
    font-size: 14px;
    font-weight: 600;
  }
  .ant-picker-suffix {
    margin-left: 6px;
    img {
      width: 16px;
      height: 16px;
      display: block;
    }
  }
`;
